import React, { Component } from 'react'
import { Link } from 'gatsby'
import Fade from 'react-reveal/Fade'

class TeamProfile extends Component {

  render() {

    let { title, slug, acf, page, last } = this.props
    if (!acf.thumbnailImage) return null

    let ytrans = (Number(!!acf.jobTitle) + Number(!!acf.licenseTitle)) * 30

    return (
      <section className={'team-card' + (page === "WFLanding"? " team-card_WFLanding" : "") + (last? " team-card_WFLanding_last" : "")}>
        <Link to={`/team/${slug}`}>
          <Fade bottom distance='25px'>
            <>
              { acf.thumbnailImage && <img src={acf.thumbnailImage.localFile.publicURL} alt={title} /> }
              <p style={{transform: `translate(0, ${ytrans}px)`}}>
                <span>{title}</span>
                { acf.jobTitle && <span className='team-card__title'>{acf.jobTitle}</span> }
                { acf.licenseTitle && <span className='team-card__title team-card__license'>{acf.licenseTitle}</span> }
              </p>
            </>
          </Fade>
        </Link>
      </section>
    )
  }
}

export default TeamProfile
